import React from 'react';
import Colic from '../../../../static/profilBilder/Colic.jpg';
import Kraiger from '../../../../static/profilBilder/Kraiger.jpg';
import Neubert from '../../../../static/profilBilder/Neubert.jpg';
import RugbyLogo from '../../../../static/logos/RBA_logo.png';
import './Struktur.css';

const AboutStruktur = () => {
  return (
    <div className="about-struktur">
      <div className="about-struktur__section-header">
        <h2>VORSTAND</h2>
      </div>
      <div className="about-struktur__section-content">
        <div className="about-struktur__section-item">
          <img src={Colic} alt="Profilbild Branimir Niko Colic" />
          <div className="about-struktur__section-item-content">
            <h3>Branimir Niko Colic <br />
              Vorsitzender RBA</h3>
            <a href="mailto:rba-vorsitz@rugbydeutschland.org" target="_blank" rel="noopener">rba-vorsitz@rugbydeutschland.org</a>
          </div>
        </div>
        <div className="about-struktur__section-item">
          <img src={Neubert} alt="Profilbild Sven Neubert" />
          <div className="about-struktur__section-item-content">
            <h3>Sven Neubert <br />
              Stellv. Vorsitzender RBA</h3>
            <a href="mailto:rba.stellvertreter@rugbydeutschland.org">rba.stellvertreter@rugbydeutschland.org</a>
          </div>
        </div>
        <div className="about-struktur__section-item">
          <img src={Kraiger} alt="Profilbild Helmut Kraiger" />
          <div className="about-struktur__section-item-content">
            <h3>Helmut Kraiger <br />
              15er Spielbetrieb RBA</h3>
            <a href="mailto:rba.xv@rugbydeutschland.org">rba.xv@rugbydeutschland.org</a>
          </div>
        </div>
      </div>
      <div className="about-struktur__section-header">
        <h2>STAFFELLEITER</h2>
      </div>
      <div className="about-struktur__section-content">
        <div className="about-struktur__section-item">
          <img src={RugbyLogo} alt="Platzhalter für Profilbild" />
          <div className="about-struktur__section-item-content">
            <h3>Arnaud Tribbelini <br />
              Staffelleiter Nord/Ost</h3>
            <a href="mailto:2blno@rugbydeutschland.org" target="_blank" rel="noopener">2blno@rugbydeutschland.org</a>
          </div>
        </div>
        <div className="about-struktur__section-item">
          <img src={RugbyLogo} alt="Platzhalter für Profilbild" />
          <div className="about-struktur__section-item-content">
            <h3>Bernhard Eschwe <br />
              Staffelleiter Süd/West</h3>
            <a href="mailto:2blsw@rugbydeutschland.org" target="_blank" rel="noopener">2blsw@rugbydeutschland.org</a>
          </div>
        </div>
      </div>
      <div className="about-struktur__section-header">
        <h2>KOMMUNIKATION & MEDIEN</h2>
      </div>
      <div className="about-struktur__section-content">
        <div className="about-struktur__section-item">
          <img src={RugbyLogo} alt="Platzhalter für Profilbild" />
          <div className="about-struktur__section-item-content">
            <h3>Paul Williams <br />
              Socialmediabeauftragter
            </h3>
            <a href="mailto:socialmediabl@rugbydeutschland.org" target="_blank" rel="noopener">socialmediabl@rugbydeutschland.org</a>
          </div>
        </div>
        <div className="about-struktur__section-item">
          <img src={RugbyLogo} alt="Platzhalter für Profilbild" />
          <div className="about-struktur__section-item-content">
            <h3>Tobias Bleckmann<br />
              Livestream & Video Beauftragter
            </h3>
            <a href="mailto:videoBL@rugbydeutschland.org" target="_blank" rel="noopener">videoBL@rugbydeutschland.org</a>
          </div>
        </div>
        <div className="about-struktur__section-item">
          <img src={RugbyLogo} alt="Platzhalter für Profilbild" />
          <div className="about-struktur__section-item-content">
            <h3>Björn Frommann<br />
              Trainersymposien & Wissenstransfer Beauftragter
            </h3>
            <a href="mailto:coachingbl@rugbydeutschland.org" target="_blank" rel="noopener">coachingbl@rugbydeutschland.org</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutStruktur;
